// ** Reducers Imports

import auth from './authentication'
import steps from '@pages/probate/globalstore'
import eligibilty from '@pages/probate/Eligibility_1/store'
import verification from '@pages/probate/VerificationDeceasedInfo_2/store'
import applicationform from '@pages/probate/Form_3/store'
import docchecklist from '@pages/probate/DocumentChecklist_4/store';
import startprobate from '@pages/startprobate/store';
import scheduleofassets from '@pages/probate/ScheduleOfAssets_5/store';
import submission from '@pages/probate/Submission_6/store';
import adminoathaffidavit from '@pages/probate/AdministrationOathAndSupplementaryAffidavit_7/store';
import hearing from '@pages/probate/Hearing_8/store';
import extractionofgrant  from '@pages/probate/ExtractionOfGrant_9/store';
import notification from '@pages/notifications/store';
import paymenthistory from '@pages/payment/History/store';
import needHelp from "@jds/NeedHelp/store"
import refunddetailsmodel from "../views/pages/payment/NotificationAlert/Refund/store"

//import pyamentmodal from '@pages/payment/Modal/store';
const rootReducer = {
  auth,
  startprobate,
  steps,
  eligibilty,
  verification,
  applicationform,
  docchecklist,
  scheduleofassets,
  submission,
  adminoathaffidavit,
  extractionofgrant,
  notification,
  hearing,
  paymenthistory,
  needHelp,
  refunddetailsmodel
  //pyamentmodal    
}

export default rootReducer
